<script lang="ts">
    import { page } from '$app/stores';
    import { claimFirstImage } from '$lib/Stores/imagePriority';
    import { cn } from '$lib/utils/cn';

    import Imgix from 'imgix-core-js';

    export let alt = '';
    export let src = '';
    export let ratio: string | null = null;
    export let sizes = '(max-width: 1000px) 100vw, 1000px';
    export let imgixParams: {
        w?: number;
        h?: number;
        ar?: string | number;
        [key: string]: unknown;
    } = {};
    export let className = '';

    const isFirstImage = claimFirstImage($page.url.pathname);

    // Gif can cause Imgix to timeout, since they can be very big
    // Srcset will create very big images, this is what we need to prevent for gifs
    // Read more: https://community.datocms.com/t/problem-loading-large-animated-gif-images-edited-title/5048/23
    const isGif = src.includes('.gif');

    const domain = new URL(src).hostname;
    const path = decodeURI(new URL(src).pathname);
    const imgix = new Imgix({ domain, includeLibraryParam: false });
    const srcset = imgix.buildSrcSet(path, imgixParams);

    // Convert ratio from percentage string (e.g., "75%") to CSS aspect-ratio (e.g., "4 / 3")
    // ratio is (height / width) * 100, so aspect-ratio = width / height = 100 / ratioValue
    const getAspectRatio = (): string | null => {
        if (ratio) {
            const ratioValue = parseFloat(ratio);

            if (!isNaN(ratioValue) && ratioValue > 0) {
                // Return as "width / height" format
                return `${100} / ${ratioValue}`;
            }
        }

        // Try to derive from imgixParams
        if (imgixParams.w && imgixParams.h) {
            return `${imgixParams.w} / ${imgixParams.h}`;
        }

        if (imgixParams.ar && typeof imgixParams.ar === 'string') {
            // ar format is "width:height", convert to "width / height"
            return imgixParams.ar.replace(':', ' / ');
        }

        return null;
    };

    const aspectRatio = getAspectRatio();
</script>

<div class="fun-relative fun-w-full">
    <img
        {src}
        {alt}
        srcset={isGif ? '' : srcset}
        {sizes}
        loading={isFirstImage ? 'eager' : 'lazy'}
        fetchpriority={isFirstImage ? 'high' : undefined}
        class={cn('fun-w-full fun-object-cover fun-object-center', className)}
        style={aspectRatio ? `aspect-ratio: ${aspectRatio};` : undefined}
    />
</div>
